module.exports = require("./PluginInfo.vue");